<template lang="pug">
  .map-modal
    Modal(ref='modal' title="Pick coordinates" :closeable="true" @confirm="onConfirm(marker.position)" )
      label Latitude:
      span &nbsp; {{marker.position.lat}}&nbsp;
      label Longitude:
      span &nbsp; {{marker.position.lng}}
      GmapMap.map(:center="center" :markers="markers" :zoom="2")
        GmapMarker(v-if="marker" :markers="markers" :position="marker.position" :clickable="false" :draggable="true" @dragend="pick")
</template>


<script>
import GmapLazy from '@/utils/GmapLazy'
import Modal from '@/components/common/Modal'

export default {
  props: ['value'],
  mounted() {
    GmapLazy.loadGmap().then(() => {
      // map loaded
    })
  },
  data() {
    return {
      center: { lat: 0, lng: 0 },
      marker: {
        position: { lat: 0, lng: 0 }
      },
      markers: [this.marker]
    }
  },
  watch: {
    value(v) {
      this.marker.position = { ...v }
    }
  },
  methods: {
    open(onConfirm) {
      this.$refs.modal.open()
      this.onConfirm = onConfirm
    },
    pick(c) {
      this.marker.position = { lat: c.latLng.lat(), lng: c.latLng.lng() }
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss" scoped>
.map-modal {
  label {
    color: grey;
  }
  .map {
    width: 650px;
    height: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/CoordinatesPicker.vue